// Puerta de acceso temporal de la v1 mientras dura la migracion.
// El administrador le entrega el codigo del dia al personal de trabajo.
// Codigo = dia del mes x 2 + 1  (ej: dia 16 -> 33)

const STORAGE_KEY = "accessGateDay";

// El dia se calcula siempre en hora de Lima, no con la del equipo,
// para que el codigo no cambie a destiempo si alguien tiene mal
// configurada la zona horaria.
export function currentDayKey() {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Lima",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());

  const value = (type) => parts.find((part) => part.type === type).value;

  return `${value("year")}-${value("month")}-${value("day")}`;
}

export function expectedCode() {
  const day = Number(currentDayKey().slice(-2));

  return String(day * 2 + 1);
}

export function gateIsOpen() {
  return localStorage.getItem(STORAGE_KEY) === currentDayKey();
}

export function openGate() {
  localStorage.setItem(STORAGE_KEY, currentDayKey());
}

export function closeGate() {
  localStorage.removeItem(STORAGE_KEY);
}
